var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedBunk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 0H240C231.125 0 224 7.125 224 16V128H64V16C64 7.125 56.875 0 48 0H16C7.125 0 0 7.125 0 16V496C0 504.875 7.125 512 16 512H48C56.875 512 64 504.875 64 496V448H512V496C512 504.875 519.125 512 528 512H560C568.875 512 576 504.875 576 496V112C576 50.125 525.875 0 464 0ZM512 267.25C497 259.875 480.625 256.125 464 256H240C231.125 256 224 263.125 224 272V384H64V192H512V267.25ZM144 352C170.5 352 192 330.5 192 304S170.5 256 144 256S96 277.5 96 304S117.5 352 144 352ZM144 96C170.5 96 192 74.5 192 48S170.5 0 144 0S96 21.5 96 48S117.5 96 144 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedBunk);
export default __webpack_public_path__ + "static/media/bed-bunk.5599cfceafd0c1ec329f27fa3fa4758b.svg";
export { ForwardRef as ReactComponent };